package floris.graphics.backoffice.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.materialdesignsystem.components.Spacer
import com.materialdesignsystem.toColorScheme
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@Composable
fun DetailsSection(
    modifier: Modifier = Modifier,
    title: String,
    initiallyExpanded: Boolean = false,
    content: @Composable () -> Unit
) {
    val colorScheme = ColorMode.current.toColorScheme
    var expanded by remember { mutableStateOf(initiallyExpanded) }

    Column(
        modifier
            .border(1.px, LineStyle.Solid, Colors.LightGray)
            .borderRadius(8.px)
            .background(colorScheme.surfaceVariant)
            .padding(16.px)
    ) {
        Box(
            Modifier
                .onClick { expanded = !expanded }
                .styleModifier { property("cursor", "pointer") },
        ) {
            Text(title + " " + if (expanded) "▲" else "▼")
        }

        if (expanded) {
            Spacer(Modifier.height(12.px))
            content()
        }
    }
}

